<form>
    <p>
      {{ passwordStrings.description1 }} {{ passwordStrings.description2 }}
    </p>

    <p *ngIf="useValidationMessageSetting" [innerHTML]="passwordValidationMessage"></p>
    <p *ngIf="!useValidationMessageSetting">
      1. {{ passwordStrings.requirement1 }}<br>
      2. {{ passwordStrings.requirement2 }}<br>
      3. {{ passwordStrings.requirement3 }} {{ passwordStrings.requirement3symbols }}<br>

    <div class="form-group" *ngIf="needOldPassword">
      <label class="required" for="oldPassword">{{ strings.currentPassword }}</label>
      <ti-input-validation-wrap [firstSubmit]="firstSubmit" [config]="{inputWithSecondIcon: true}" [control]="oldPsw">
        <ti-field-eye>
          <input type="password"
            class="form-control"
            id="oldPassword"
            [(ngModel)]="oldPassword"
            #oldPsw="ngModel"
            name="oldPassword"
            [title]="strings.currentPassword"
            required
          />
        </ti-field-eye>
      </ti-input-validation-wrap>
      <div class="invalid-feedback">
        <span *ngIf="oldPsw.hasError('required')">
          {{ errStrings.thisFieldIsRequired }}
        </span>
      </div>
    </div>

    <div [formGroup]="changePasswordForm">
      <div class="form-group mb-0">
        <label class="required" for="password">{{ strings.newPassword }}</label>
        <ti-input-validation-wrap [firstSubmit]="firstSubmit" [config]="{inputWithSecondIcon: true}" [control]="changePasswordForm.get('password')">
          <ti-field-eye>
            <input type="password"
              formControlName="password"
              class="form-control"
              id="password"
              [title]="strings.newPassword"/>
          </ti-field-eye>
        </ti-input-validation-wrap>
        <div class="invalid-feedback" *ngIf="changePasswordForm.get('password').errors; let errors">
          <span *ngIf="errors['required']; else minLength"> {{ errStrings.thisFieldIsRequired }} </span>
          <ng-template  #minLength>
            <span *ngIf="errors['minlength']; else requirements"> {{ errStrings.minimumLengthOfThisField | tiStringFormat: passwordMinLength }} </span>
          </ng-template>
          <ng-template #requirements>
            <span *ngIf="errors['passwordValidator']" [innerHTML]="passwordValidationMessage"></span>
          </ng-template>
        </div>
        <!--ti-password-strength-meter
          [passwordToCheck]="changePasswordForm.get('password').value">
        </ti-password-strength-meter-->
      </div>

      <div class="form-group">
        <label class="required" for="confirm-password">{{ strings.confirmNewPassword }}</label>
        <ti-input-validation-wrap
          [firstSubmit]="firstSubmit"
          [config]="{inputWithSecondIcon: true}"
          [control]="changePasswordForm.get('confirmPassword').errors ? changePasswordForm.get('confirmPassword') : changePasswordForm"
        >
          <ti-field-eye>
            <input type="password"
              formControlName="confirmPassword"
              class="form-control"
              id="confirm-password"
              [title]="strings.confirmNewPassword"/>
          </ti-field-eye>
        </ti-input-validation-wrap>

        <div class="invalid-feedback">
          <ng-container *ngIf="changePasswordForm.get('confirmPassword').errors; let errors; else notEqual;">
            <span *ngIf="errors['required']"> {{ errStrings.thisFieldIsRequired }} </span>
          </ng-container>
          <ng-template #notEqual>
            <span *ngIf="changePasswordForm.hasError('notMatchPassword')"> {{ errStrings.notEqualError }}</span>
          </ng-template>
        </div>
      </div>
    </div>

    <div *ngIf="!modalUseMode" class="form-bottom-buttons align-items-center justify-content-between">
      <a (click)="goToLoginService.goToLogin({logOff: true})" [title]="strings.backToLogin">
        &lt; <b>{{ strings.backToLogin }}</b>
      </a>
      <button
        type="submit"
        class="btn btn-next"
        (click)="setNewPassword()"
      >
        {{ strings.setNewPassword }}
      </button>
    </div>
  </form>
